<template>
  <div class="property-detail bg-white">
    <div class="container-fluid">
      <sidebar />
      <div class="col-md-9 col-lg-10 ml-md-auto py-4">
        <div class="header d-flex justify-content-between w-100 align-items-center py-3 mb-3 border-bottom border-dark">
          <h2 class="m-0" v-html="$t('h2_edit-property', [$t(`${$route.params.type}-property`)])"></h2>
        </div>
      </div>
      <edit-business-property-form v-if="$route.params.type === 'business'" apiType="admin" />
      <edit-rental-residential-property-form v-if="$route.params.type === 'rental-residential'" />
      <edit-rental-commercial-property-form v-if="$route.params.type === 'rental-commercial'" />
    </div>
  </div>
</template>

<script>
import sidebar from '@/components/_sidebar/sidebar'
import editBusinessPropertyForm from './components/edit_business_property.vue'
import editRentalResidentialPropertyForm from './components/edit_rental_residential_property.vue'
import editRentalCommercialPropertyForm from './components/edit_rental_commercial_property.vue'

export default {
  components: {
    sidebar,
    editBusinessPropertyForm,
    editRentalResidentialPropertyForm,
    editRentalCommercialPropertyForm
  }
}
</script>
